/**
 * @generated SignedSource<<6b893a17174cfd32d51945b5299fd042>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type PipelineLineLastRunFragment$data = {
  readonly buildTypes: {
    readonly buildType: ReadonlyArray<{
      readonly builds: {
        readonly build: ReadonlyArray<{
          readonly finishDate: string | null;
          readonly rawId: number | null;
          readonly startEstimate: string | null;
          readonly state: BuildState | null;
          readonly " $fragmentSpreads": FragmentRefs<"RunStatusFragment" | "useRunningBuildUpdaterRelayFragment">;
        }> | null;
      } | null;
    }> | null;
  } | null;
  readonly " $fragmentType": "PipelineLineLastRunFragment";
};
export type PipelineLineLastRunFragment$key = {
  readonly " $data"?: PipelineLineLastRunFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineLineLastRunFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineLineLastRunFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BuildTypes",
      "kind": "LinkedField",
      "name": "buildTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BuildTypeRest",
          "kind": "LinkedField",
          "name": "buildType",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "locator",
                  "value": "count:1,state:any"
                }
              ],
              "concreteType": "Builds",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Build",
                  "kind": "LinkedField",
                  "name": "build",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rawId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startEstimate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "finishDate",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RunStatusFragment"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "useRunningBuildUpdaterRelayFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "builds(locator:\"count:1,state:any\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectRest",
  "abstractKey": null
};

(node as any).hash = "54c5c19b2fec174999f2da8b68ec72c8";

export default node;
